export default function isStatusInProgress(status: string) {
    return status === "CREATE_IN_PROGRESS" || status === "UPDATE_IN_PROGRESS";
  }